<style lang="scss" scoped>
  .container {
    position: relative;
    z-index: 1;
    margin: 0 auto;
    padding: 0 20px;
    width: 1060px;
    max-width: 100%;
  }

  .top-block {
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @include media(max, lg) {
      margin-bottom: 30px;
    }
  }

  .title {
    margin: 0;
    font-size: 44px;
    line-height: 1.09;
    font-weight: 600;
    letter-spacing: 0.005em;

    @include media(max, lg) {
      font-size: 32px;
      line-height: 1.12;
    }
  }

  .cards-list {
    display: flex;
    align-items: stretch;

    @include media(max, lg) {
      margin: 0 -20px;
      padding: 0 20px;
      overflow-x: auto;
    }
  }

  .card {
    padding: 218px 30px 30px;
    font-size: 18px;
    line-height: 1.33;
    font-weight: 400;
    width: 370px;
    color: #333;
    background: #fff no-repeat 50% 0;
    background-size: 100% auto;
    border-radius: 20px;
    flex: 1 0 370px;

    &:not(:last-child) {
      margin-right: 30px;

      [dir=rtl] & {
        margin-left: 30px;
        margin-right: 0;
      }
    }

    @include media(max, lg) {
      padding: 165px 16px 16px;
      font-size: 16px;
      line-height: 1.38;
      width: 280px;
      flex: 1 0 280px;

      &:not(:last-child) {
        margin-right: 10px;

        [dir=rtl] & {
          margin-left: 10px;
          margin-right: 0;
        }
      }
    }

    &_traffic {
      background-image: cdn('images/b2b/features/traffic.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/features/traffic@2x.png');
      }
    }

    &_drweb {
      background-image: cdn('images/b2b/features/drweb.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/features/drweb@2x.png');
      }
    }

    &_cloud {
      background-image: cdn('images/b2b/features/cloud.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/features/cloud@2x.png');
      }
    }

    &_push {
      background-image: cdn('images/b2b/features/push.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/features/push@2x.png');
      }
    }

    &_connection {
      background-image: cdn('images/b2b/features/connection.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/features/connection@2x.png');
      }
    }

    &_payment {
      background-image: cdn('images/b2b/features/payment.png');

      @media (-webkit-min-device-pixel-ratio: 2),
      (min-resolution: 192dpi) {
        background-image: cdn('images/b2b/features/payment@2x.png');
      }
    }
  }

  .card-title {
    margin-bottom: 10px;
    font-size: 30px;
    line-height: 1.13;
    font-weight: 700;
    letter-spacing: 0.005em;

    @include media(max, lg) {
      font-size: 24px;
      line-height: 1.17;
    }
  }

  .overview-link {
    color: #16a7ff;

    &:hover {
      color: #56bfff;
    }

    svg {
      display: inline-block;
      vertical-align: -4px;
    }

    [dir=rtl] & {
      svg {
        transform: rotate(180deg);
      }
    }

    @include media(max, md) {
      display: none;
    }
  }

  .btn-mobile {
    display: none;
    margin-top: 30px;
    padding: 12px;
    font-size: 18px;
    line-height: 1.78;
    text-align: center;
    color: #d8d8d8;
    background: #454549;
    box-shadow: 0 30px 50px -16px rgba(0, 9, 180, 0.3);
    border-radius: 8px;

    svg {
      vertical-align: -4px;
    }

    @include media(max, md) {
      display: block;
    }
  }

</style>

<template>
  <div class="container">
    <div class="top-block">
      <h2 class="title">
        {{$t('title')}}
      </h2>
      <a href="//documentation.vkplay.ru/overview_vkp/platform_overview_vkp" class="overview-link">
        {{$t('link')}}
        <icon name="angle" />
      </a>
    </div>

    <div class="cards-list" ref="scrollContainer" id="cards-scroll-container">
      <div class="card card_traffic">
        <h3 class="card-title">
          {{$t('traffic.name')}}
        </h3>
        <div class="card-descr">
          {{$t('traffic.descr')}}
        </div>
      </div>

      <a
        href="http://www.drweb.ru"
        target="_blank"
        rel="noopener noreferrer"
        class="card card_drweb"
        @click="handleDrWebClick"
        ref="drWebLink"
      >
        <h3 class="card-title">
          {{$t('drweb.name')}}
        </h3>
        <div class="card-descr">
          {{$t('drweb.descr')}}
        </div>
      </a>

      <div class="card card_cloud">
        <h3 class="card-title">
          {{$t('cloud.name')}}
        </h3>
        <div class="card-descr">
          {{$t('cloud.descr')}}
        </div>
      </div>

      <div class="card card_push">
        <h3 class="card-title">
          {{$t('push.name')}}
        </h3>
        <div class="card-descr">
          {{$t('push.descr')}}
        </div>
      </div>

      <div class="card card_connection">
        <h3 class="card-title">
          {{$t('connection.name')}}
        </h3>
        <div class="card-descr">
          {{$t('connection.descr')}}
        </div>
      </div>

      <div class="card card_payment">
        <h3 class="card-title">
          {{$t('payment.name')}}
        </h3>
        <div class="card-descr">
          {{$t('payment.descr')}}
        </div>
      </div>
    </div>

    <btn
      href="//documentation.vkplay.ru/overview_vkp/platform_overview_vkp"
      target="_blank"
      variant="muted"
      class="fs-18 btn-main btn-mobile">
      {{$t('link')}}
      <icon name="angle"/>
    </btn>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { isMobile } from '@vkplay/shared';
import { sendExtraEvents } from '@utils/counters';

export default {
  name: 'Features',
  i18n: {
    messages: {
      ru: {
        title: 'Преимущества',
        link: 'Обзор всех возможностей',
        traffic: {
          name: 'Трекинг трафика',
          descr: 'Мощные инструменты для отслеживания эффективности UA.',
        },
        drweb: {
          name: 'Защищено Dr. WEB',
          descr: 'Решение для защиты персональных компьютеров, мобильных устройств, планшетов',
        },
        cloud: {
          name: 'Бесплатная инфраструктура',
          descr: 'Для раздачи различных дистрибутивов.',
        },
        push: {
          name: 'Маркетинг пуш',
          descr: 'Стартовый пуш в 350 тысяч показов и дальнейшая поддержка исходя из метрик.',
        },
        connection: {
          name: 'Простое быстрое подключение',
          descr: 'Для всех видов игр: f2p, b2p, html5 и др.',
        },
        payment: {
          name: 'Стабильные выплаты',
          descr: 'В срок, без региональных ограничений.',
        },
      },
      en: {
        title: 'Advantages',
        link: 'An overview of all features',
        traffic: {
          name: 'Traffic Tracking',
          descr: 'Powerful tools to track UA effectiveness.',
        },
        drweb: {
          name: 'Protected by Dr. WEB',
          descr: 'A solution for protecting personal computers, mobile devices, and tablets',
        },
        cloud: {
          name: 'Free Infrastructure',
          descr: 'To spread different distributions.',
        },
        push: {
          name: 'Marketing Push',
          descr: 'A starting push of 350,000 impressions and further support based on metrics.',
        },
        connection: {
          name: 'Fast and Easy Connection',
          descr: 'For all types of game: F2P, B2P, HTML5, etc.',
        },
        payment: {
          name: 'Stable Payouts',
          descr: 'On time and without regional limitations.',
        },
      },
      de: {
        title: 'Vorteile',
        link: 'Eine Übersicht über alle Funktionen',
        traffic: {
          name: 'Traffic-Tracking',
          descr: 'Mächtige Werkzeuge zum Tracken der Nutzerakquise-Effektivität',
        },
        drweb: {
          name: 'Geschützt durch Dr. WEB',
          descr: 'Eine Lösung zum Schutz von Personalcomputern, Mobilgeräten und Tablets',
        },
        cloud: {
          name: 'Kostenlose Infrastruktur',
          descr: 'Zum verteilen verschiedener Veröffentlichungen',
        },
        push: {
          name: 'Marketing-Push',
          descr: 'Ein anfänglicher Push von über 350.000 Sichtungen und mehr basierend auf Metriken.',
        },
        connection: {
          name: 'Schnelle und einfache Verbindung',
          descr: 'Für alle Arten von Spielen: F2P, B2P, HTML5, etc.',
        },
        payment: {
          name: 'Stete Auszahlungen',
          descr: 'Rechtzeitig und ohne regionale Einschränkungen',
        },
      },
      fr: {
        title: 'Avantages',
        link: 'Un aperçu de toutes les fonctionnalités',
        traffic: {
          name: 'Suivi du trafic',
          descr: 'Des outils puissants pour suivre l\'efficacité UA.',
        },
        drweb: {
          name: 'Protégé par Dr. WEB',
          descr: 'Une solution pour protéger les ordinateurs personnels, appareils mobiles et tablettes',
        },
        cloud: {
          name: 'Infrastructure gratuite',
          descr: 'Pour répartir les différentes distributions.',
        },
        push: {
          name: 'Push marketing',
          descr: 'Une impulsion de départ de 350 000 impressions et un soutien supplémentaire en fonction des mesures.',
        },
        connection: {
          name: 'Connexion rapide et facile',
          descr: 'Pour tous les types de jeux : F2P, B2P, HTML5, etc.',
        },
        payment: {
          name: 'Indemnisations stables',
          descr: 'Dans les délais et sans limites régionales.',
        },
      },
      es: {
        title: 'Ventajas',
        link: 'Un resumen de todas las características',
        traffic: {
          name: 'Seguimiento de afluencia',
          descr: 'Herramientas potentes para seguir la efectividad de la AU.',
        },
        drweb: {
          name: 'Protegido por Dr. WEB',
          descr: 'Una solución para proteger ordenadores personales, dispositivos móviles y tabletas',
        },
        cloud: {
          name: 'Infraestructura gratuita',
          descr: 'Para distintas distribuciones.',
        },
        push: {
          name: 'Empuje publicitario',
          descr: 'Un empuje inicial de 350 000 impresiones y más asistencia basada en mediciones.',
        },
        connection: {
          name: 'Conexión rápida y fácil',
          descr: 'Para todo tipo de juegos: gratis, B2P, HTML5, etc.',
        },
        payment: {
          name: 'Pagos estables',
          descr: 'A tiempo y sin limitaciones regionales.',
        },
      },
      pl: {
        title: 'Zalety',
        link: 'Przegląd wszystkich funkcji',
        traffic: {
          name: 'Śledzenie ruchu',
          descr: 'Potężne narzędzia pozwalające śledzić skuteczność pozyskiwania użytkowników.',
        },
        drweb: {
          name: 'Chronione przez Dr. WEB',
          descr: 'Rozwiązanie do ochrony komputerów osobistych, urządzeń mobilnych i tabletów',
        },
        cloud: {
          name: 'Darmowa infrastruktura',
          descr: 'W celu wykorzystania różnych systemów dystrybucji.',
        },
        push: {
          name: 'Działalność marketingowa',
          descr: 'Początkowe 350 000 wyświetleń i dalsze wsparcie w zależności od wskaźników.',
        },
        connection: {
          name: 'Szybkie i wygodne połączenie',
          descr: 'Dla wszelkiego rodzaju gier: F2P, B2P, HTML5 itd.',
        },
        payment: {
          name: 'Stałość wypłat',
          descr: 'Na czas i bez ograniczeń regionalnych.',
        },
      },
      tr: {
        title: 'Avantajları',
        link: 'Tüm özelliklere genel bakış',
        traffic: {
          name: 'Trafik takibi',
          descr: 'UA verimliliğinin takibi için güçlü araçlar',
        },
        drweb: {
          name: 'Dr. WEB ile Korunuyor',
          descr: 'Kişisel bilgisayarları, mobil cihazları ve tabletleri koruma çözümü',
        },
        cloud: {
          name: 'Ücretsiz Altyapı',
          descr: 'Farklı dağıtımları yaymak için.',
        },
        push: {
          name: 'Pazarlama Desteği',
          descr: 'Başlangıçta 350.000 görüntülenmeyle desteklenir ve sonrasında metriklere göre ek destek sağlanır.',
        },
        connection: {
          name: 'Hızlı ve Kolay Bağlantı',
          descr: 'Her türden oyun için: F2P, B2P, HTML5, vb.',
        },
        payment: {
          name: 'Düzenli Ödemeler',
          descr: 'Ülke kısıtlaması olmadan zamanında ödemeler.',
        },
      },
      ar: {
        title: 'المزايا',
        link: 'نظرة عامة على جميع الميزات',
        traffic: {
          name: 'تعقب حركة المرور',
          descr: 'أدوات قوية لتعقب فاعلية UA',
        },
        drweb: {
          name: 'محمي بواسطة Dr. WEB',
          descr: 'حل لحماية أجهزة الكمبيوتر الشخصية والأجهزة المحمولة والأجهزة اللوحية',
        },
        cloud: {
          name: 'بنية تحتية مجانية',
          descr: 'لنشر توزيعات مختلفة.',
        },
        push: {
          name: 'دفعة تسويقية',
          descr: 'دفعة في البداية من 350 ألف انطباع والمزيد من الدعم بناءً على القياسات.',
        },
        connection: {
          name: 'اتصال سريع وسهل',
          descr: 'لجميع أنواع الألعاب: المجانية والمدفوعة والأونلاين، وغيرها.',
        },
        payment: {
          name: 'مدفوعات مستقرة',
          descr: 'في الوقت المناسب وبدون قيود إقليمية.',
        },
      },
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);

    const isSmallScreen = window.matchMedia('(max-width: 1049px)').matches;
    const containerElem = this.$refs.scrollContainer;
    const panels = gsap.utils.toArray('#cards-scroll-container .card');
    const isRtl = document.dir === 'rtl';
    const scrollOffset = window.innerWidth > 1320 ? containerElem.offsetWidth * 1.15 : containerElem.offsetWidth;
    const scrollWidth = -containerElem.scrollWidth + scrollOffset;
    const endWidth = containerElem.scrollWidth - window.innerWidth;

    if (!(isMobile || isSmallScreen)) {
      gsap.to(panels, {
        x: () => isRtl ? -scrollWidth : scrollWidth,
        ease: "none",
        scrollTrigger: {
          trigger: "#cards-scroll-container",
          pin: '.features',
          start: '50% 50%',
          scrub: 1,
          end: () => `+=${isRtl ? -endWidth : endWidth}`,
        },
      });
    }

    this.observeElement();
  },
  methods: {
    handleDrWebClick() {
      sendExtraEvents({
        category: 'support',
        action: 'dev_welcome_dr_web_click',
        label: window.location.href,
      });
    },
    observeElement() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.handleIntersection();
              observer.disconnect();
            }
          });
        },
        {
          threshold: 0.5,
        },
      );

      if (this.$refs.drWebLink) {
        observer.observe(this.$refs.drWebLink);
      }
    },
    handleIntersection() {
      sendExtraEvents({
        category: 'support',
        action: 'dev_welcome_dr_web_show',
        label: window.location.href,
      });
    },
  },
};

</script>
